var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{on:{"click":_vm.handleToggleDropdown}},[_vm._v("\n    Produits\n    "),_c('ul',{staticClass:"dropdown--content",class:{active: _vm.isActive}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }